import { ApiError } from '@/lib/api/ApiError';
import { CoiGenerationTimeoutError } from '@/lib/api/documents';
import { toApiErrorCategory, type ErrorCategory } from './errorCategory';

export const toCoiErrorCategory = (error: unknown): ErrorCategory => {
  if (error instanceof CoiGenerationTimeoutError) return 'generation_timeout';

  if (error instanceof ApiError) return toApiErrorCategory(error.status);

  // A blocked or failed fetch rejects with a TypeError, not an ApiError.
  if (error instanceof TypeError) return 'network';

  return 'unknown';
};
